/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Smb_No_Agent_ConnectedInputs */



/**
* | output |
* | --- |
* | "No relay is connected. Connect an oneAI Relay first." |
*
* @param {Spaces_Smb_No_Agent_ConnectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_smb_no_agent_connected = /** @type {((inputs?: Spaces_Smb_No_Agent_ConnectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Smb_No_Agent_ConnectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Relay ist verbunden. Verbinden Sie zuerst ein oneAI-Relay.")
	return /** @type {LocalizedString} */ ("No relay is connected. Connect an oneAI Relay first.")
});